import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pipeline } from './projects.types';

@Injectable({ providedIn: 'root' })
export class PipelineService {
  constructor(private readonly httpClient: HttpClient) {}

  get(): Observable<Pipeline[]> {
    return this.httpClient.get<{ pipelines: Pipeline[] }>(`pipelines`).pipe(map(({ pipelines }) => pipelines));
  }

  getByIdAndAccount(id: number, accountId: number): Observable<Pipeline> {
    return this.httpClient.get<{ pipeline: Pipeline }>(`pipelines/${id}`).pipe(map(({ pipeline }) => pipeline));
  }

  update(pipeline: Pipeline, accountId: number): Observable<Pipeline> {
    return this.httpClient
      .put<{ pipeline: Pipeline }>(`pipelines/${pipeline.id}`, { pipeline })
      .pipe(map(({ pipeline }) => pipeline));
  }
}
